import React, { Fragment, forwardRef, useRef, useEffect, useMemo, useState, useCallback } from "react";
import { useSelector } from "react-redux";

import COMMON from "common";
import AppScreenLoading from "components/app-screen-loading";
import AppSelectCompanyModal from "components/app-select-company";

const withCompanies = (WrappedComponent) => {
	return forwardRef(({ ...props }, ref) => {
		const loadingRef = useRef();
		const onLoadTimeout = useRef();
		const selectCompanyRef = useRef();
		const profile = useSelector((state) => state.profile);
		const company = useMemo(() => profile?.company?.businessRegistrationNo, [profile]);
		const onHandleGetProfile = useMemo(() => props.onHandleGetProfile, [props]);
		const onHandleCancelProfile = useMemo(() => props.onHandleCancelProfile, [props]);
		const [initialized, setInitialized] = useState(false);

		const onHandleSelectCompany = useCallback((callback) => {
			selectCompanyRef.current.onHandleShow(callback);
		}, []);

		useEffect(() => {
			const localToken = localStorage.getItem(COMMON.AUTH_TOKEN);
			const sessionToken = sessionStorage.getItem(COMMON.AUTH_TOKEN);
			const token = localToken || sessionToken;

			if (!company && token) {
				onLoadTimeout.current = setTimeout(() => {
					selectCompanyRef.current.onHandleShow();
				}, 1000);
			} else if (token) {
				loadingRef.current.onHandleShow();

				onLoadTimeout.current = setTimeout(() => {
					onHandleGetProfile(() => {
						setInitialized(true);
						loadingRef.current.onHandleDismiss();
					});
				}, 1000);
			}

			return () => {
				clearTimeout(onLoadTimeout.current);
				onHandleCancelProfile(COMMON.ENDPOINT_PATH.GENERAL.PROFILE);
			};
		}, [company, onHandleCancelProfile, onHandleGetProfile]);

		const contextProps = useMemo(() => ({ onHandleSelectCompany }), [onHandleSelectCompany]);

		return (
			<Fragment>
				<AppScreenLoading ref={loadingRef} />

				<WrappedComponent ref={ref} {...props} {...contextProps} initialized={initialized} />

				<AppSelectCompanyModal ref={selectCompanyRef} />
			</Fragment>
		);
	});
};
export default withCompanies;
